// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePatientAccountApi = class EdgePatientAccountApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param GetCaseRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientAccountGetCase(GetCaseRequestModel, x_program_id) {
        const _url_ = '/edge/patientAccount/GetCase';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'GetCaseRequestModel' is not null or undefined
        if (GetCaseRequestModel === null || GetCaseRequestModel === undefined) {
            throw new Error('Required parameter GetCaseRequestModel was null or undefined when calling patientAccountGetCase.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(GetCaseRequestModel, "GetCaseRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientAccountGetPatientAccount(x_program_id) {
        const _url_ = '/edge/patientAccount/GetPatientAccount';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetPatientAccountDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientAccountGetPatientActiveEnrollments(x_program_id) {
        const _url_ = '/edge/patientAccount/GetPatientActiveEnrollments';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountGetPatientActiveEnrollmentsDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IIsPatientRegisteredRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientAccountIsPatientRegistered(IIsPatientRegisteredRequestModel, x_program_id) {
        const _url_ = '/edge/patientAccount/IsPatientRegistered';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IIsPatientRegisteredRequestModel' is not null or undefined
        if (IIsPatientRegisteredRequestModel === null || IIsPatientRegisteredRequestModel === undefined) {
            throw new Error('Required parameter IIsPatientRegisteredRequestModel was null or undefined when calling patientAccountIsPatientRegistered.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IIsPatientRegisteredRequestModel, "IIsPatientRegisteredRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountIsPatientRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param IPatientRegistrationRequestModel default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async patientAccountPatientRegistration(IPatientRegistrationRequestModel, x_program_id) {
        const _url_ = '/edge/patientAccount/PatientRegistration';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'IPatientRegistrationRequestModel' is not null or undefined
        if (IPatientRegistrationRequestModel === null || IPatientRegistrationRequestModel === undefined) {
            throw new Error('Required parameter IPatientRegistrationRequestModel was null or undefined when calling patientAccountPatientRegistration.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(IPatientRegistrationRequestModel, "IPatientRegistrationRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountPatientRegistrationDefaultResponse");
        }
        return response;
    }
};
EdgePatientAccountApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePatientAccountApi);
export { EdgePatientAccountApi };
//# sourceMappingURL=edgePatientAccountApi.js.map